<template>
    <form @submit.prevent="updateProfileInformation">
        <base-card>
            <template #header>
                {{ $t('general.user') }}
            </template>
            <template #body>
                <div class="space-y-4">
                    <input-group v-model="form.name" name="name" :label="$t('general.name')"
                                 :form="form" required/>
                    <input-group v-model="form.email" name="email" :label="$t('general.email')"
                                 type="email" :form="form" required/>
                </div>
            </template>
            <template #footer>
                <div class="flex space-x-2 justify-end">
                    <save-button/>
                </div>
            </template>
        </base-card>
    </form>
</template>

<script>
export default {
    props: ['user'],

    data() {
        return {
            form: this.$inertia.form({
                '_method': 'PUT',
                name: this.user.name,
                email: this.user.email,
                photo: null,
            }, {
                bag: 'updateProfileInformation',
                resetOnSuccess: false,
            }),

            photoPreview: null,
        };
    },

    methods: {
        updateProfileInformation() {
            // if (this.$refs.photo) {
            //     this.form.photo = this.$refs.photo.files[0];
            // }

            this.form.post(route('user-profile-information.update'), {
                preserveScroll: true,
            });
        },

        // selectNewPhoto() {
        //     this.$refs.photo.click();
        // },
        //
        // updatePhotoPreview() {
        //     const reader = new FileReader();
        //
        //     reader.onload = (e) => {
        //         this.photoPreview = e.target.result;
        //     };
        //
        //     reader.readAsDataURL(this.$refs.photo.files[0]);
        // },
        //
        // deletePhoto() {
        //     this.$inertia.delete(route('current-user-photo.destroy'), {
        //         preserveScroll: true,
        //     }).then(() => {
        //         this.photoPreview = null;
        //     });
        // },
    },
};
</script>
